import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Label } from '@/shared/components/ui/label'
import { Input } from '@/shared/components/ui/input'
import { Button } from '@/shared/components/ui/button'
import { Logo } from '@/shared/components/Logo'
import { useLogin } from '../hooks/useLogin'
import { tokenStorage } from '@/lib/auth/tokenStorage'

export function LoginPage() {
  const [phone, setPhone] = useState('')
  const [logoHref, setLogoHref] = useState('/')
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate(`/verify-otp/${phone}`)
  }

  const { loading, login } = useLogin({ onSuccess: handleSuccess })

  useEffect(() => {
    const token = tokenStorage.getToken()
    const vendorId = tokenStorage.getVendorId()
    if (token && vendorId) {
      setLogoHref(`/dashboard/${vendorId}`)
    }
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-8">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-lg p-8 shadow-sm">
          <div className="text-center mb-8">
            <div className="w-full flex justify-center items-center mb-4">
              <Logo href={logoHref} />
            </div>
            <h1 className="text-2xl font-bold text-black">Login to Your Vendor Account</h1>
            <p className="text-gray-600 mt-2">
              Enter your phone number <br /> to access your dashboard
            </p>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault()
              login({ phone })
            }}
            className="space-y-6"
          >
            <div className="flex flex-col justify-center items-start gap-2">
              <Label>Owner Phone Number (10 digits)</Label>
              <Input value={phone} onChange={(e) => setPhone(e.target.value)} maxLength={10} required />
            </div>

            <Button disabled={loading} type="submit" className="w-full bg-green-600 text-white cursor-pointer">
              Sign in
            </Button>

            <div className="text-center">
              <span className="text-gray-600">Don't have an account? </span>
              <Link to={loading ? '' : '/register'} className="text-[#2C9C46] hover:underline">
                Register here
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
